import { type UserActionTypes, type UserState } from "../../Actions/Users/UserActions";
import {
    USER_LOADED,
    USER_LOGIN,
    USER_LOGOUT,
    USER_QUICK_MENU,
} from "../../Actions/Users/UserVariables";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";

function UserReducer(
    state: UserState | undefined,
    action: ShopfrontActions<UserActionTypes>
): UserState {
    if(typeof state === "undefined") {
        return {
            id: false,
        };
    }

    switch(action.type) {
        case USER_LOGIN:
        case USER_LOADED:
            return action.user;
        case USER_QUICK_MENU:
            if(!state.id) {
                return state;
            }

            return {
                ...state,
                quickMenu: action.quickMenu,
            };
        case USER_LOGOUT:
            return {
                id: false,
            };
        default:
            return state;
    }
}

export default UserReducer;
